import { FC, useContext, useEffect } from 'react';

import { t } from '@onlinepayments/payments-library';
import get from 'lodash.get';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import constructionImage from '../../assets/images/ill-construction.svg';
import { Card } from '../../components/toolkit';
import FullPageMessage from '../../components/toolkit/FullPageMessage';
import { Path } from '../../enums/Path';
import { PayorderBackendErrorMessage } from '../../enums/PayorderBackendErrorMessage';
import PayorderBackendErrorResponse from '../../interfaces/PayorderBackendErrorResponse';
import { PayorderContext } from '../../PayorderContext';

import notFoundImage from './assets/ill-alien.svg';

function renderErrorMessage(
  { errorMessage, status }: PayorderBackendErrorResponse,
  orderNumber = '',
) {
  let title = t('generic_error_message');
  let imgSrc = constructionImage;

  if (errorMessage?.includes(PayorderBackendErrorMessage.AmountAlreadyPaid)) {
    title = t('order.amount_already_paid_title', '', { orderNumber });
  }

  if (errorMessage?.includes(PayorderBackendErrorMessage.OrderIsCancelled)) {
    title = t('order.order_cancelled_error_message', '', { orderNumber });
  }

  if (errorMessage?.includes(PayorderBackendErrorMessage.OrderCannotBePaidOnline)) {
    title = t('order.cannot_be_paid_online');
  }

  if (errorMessage?.includes(PayorderBackendErrorMessage.OrderHasPendingPayment)) {
    title = t('order.payment_is_pending_error_message', '', { orderNumber });
  }

  if (status === 404) {
    title = t('order.not_found_title');
    imgSrc = notFoundImage;
  }

  return <FullPageMessage title={title} imgProps={{ src: imgSrc }} />;
}

const ValidateOrderFailureContainer: FC<RouteComponentProps> = ({ location }) => {
  const validationError = get(location, 'state.validationError');
  const orderNumber = get(location, 'state.orderNumber');
  const { dispatchContext } = useContext(PayorderContext);

  useEffect(() => {
    if (validationError) {
      dispatchContext({ type: 'RemoveContextIds' });
    }
  }, [validationError, dispatchContext]);

  if (!validationError) {
    return <Redirect to={Path.ValidateOrder} />;
  }

  return (
    <Card testId="ValidateOrderFailureContainer">
      {renderErrorMessage(validationError, orderNumber)}
    </Card>
  );
};

export default ValidateOrderFailureContainer;
